import {
  defaultRoadmapNoteStart,
  defaultRoadmapNoteEnd,
  defaultRenewalRoadmapNoteStart,
  defaultRenewalRoadmapNoteEnd,
  defaultPsychologyRoadmapNoteStart,
  defaultPsychologyRoadmapNoteEnd,
} from "../constants/defaultRoadmapNote";

export const normalizeUserNote = (html) => {
  if (!html) return html;
  return html
    .replace(/<p[^>]*>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, "")
    .replace(/(<p[^>]*>)(?:\s|&nbsp;)*(?:<br\s*\/?>\s*)+/gi, "$1")
    .replace(/(?:\s*<br\s*\/?>)+(?:\s|&nbsp;)*(<\/p>)/gi, "$1")
    .replace(/(<\/p>)(?:\s|&nbsp;|<br\s*\/?>)*(<p[^>]*>)/gi, "$1$2")
    .replace(/(?:\s*<br\s*\/?>\s*){2,}/gi, "<br>")
    .replace(/(?:\s*<br\s*\/?>\s*)+$/gi, "")
    .trim();
};

export const buildAutoNote = ({
  productCode,
  isRenewal = false,
  username,
  values = [],
}) => {
  const isPsychology = productCode === "roadmap-psychology";
  const noteStart = isPsychology
    ? defaultPsychologyRoadmapNoteStart
    : isRenewal
      ? defaultRenewalRoadmapNoteStart
      : defaultRoadmapNoteStart;
  const noteEnd = isPsychology
    ? defaultPsychologyRoadmapNoteEnd
    : isRenewal
      ? defaultRenewalRoadmapNoteEnd
      : defaultRoadmapNoteEnd;
  const spans = values
    .filter((v) => v != null && `${v}`.trim() !== "")
    .map((v) => `<span style="color: rgb(230, 0, 0);">${v}</span>`);
  return `${noteStart.replace("%name%", username?.trim() || "پلنیومی")}<br>${
    spans.length ? `${spans.join(" ")}<br>` : ""
  }${noteEnd}`
    .replace(/(?:<br\s*\/?>\s*){2,}/gi, "<br>")
    .replace(/(?:\s*<br\s*\/?>)+\s*$/gi, "")
    .trim();
};
